



  <h2 class="mt-4">Información cuenta</h2>

<form  [formGroup]="infoForm"  (submit)="infoSubmit()" >
  <div class="form-group">
  <label>Nombres</label>
  <input type="text" formControlName="first_name"  class="form-control" placeholder="Nombres" required autofocus>

  <label>Apellidos</label>
  <input type="text" formControlName="last_name"  class="form-control" placeholder="Apellidos" required autofocus>

  <label>Email address</label>
  <input type="email" formControlName="email"  class="form-control" placeholder="Email" required autofocus>

  <button class="btn btn-outline-secondary" >Salvar</button>
</div>
</form>

<h2 class="mt-4">Cambiar Contraseña</h2>
<hr>

<form  [formGroup]="passwordForm"  (submit)="passwordSubmit()" >
  <div class="form-group">

  <label>Password</label>
  <input type="password" formControlName="password"  class="form-control" placeholder="Password" required>

  <label>Password Confirm</label>
  <input type="password" formControlName="password_confirm"  class="form-control" placeholder="Password Confirm" required>

  <button class="btn btn-outline-secondary" type="submit">Sign in</button>
</div>
</form>


